// lỗi TPB bank trả về
export const dataErrorPVC = {
    
    ["6"]: {text: "Tài khoản đang tạm khóa"},
    ["10"]: {text: "Khuôn mặt chưa được đăng ký"},
    ["21"]: {text: "Không nhận diện được khuôn mặt"},
    ["40"]: {text: "Dữ liệu đầu vào không hợp lệ"},
    ["43"]: {text: "Hệ thống bị lỗi truy cập"},
    ["46"]: {text: "Giao dịch không thành công do lỗi hệ thống"},
    ["53"]: {text: "Dịch vụ Facepay không khả dụng"},
    ["5008"]: {text: "Yêu cầu không hợp lệ"},
    ["5010"]: {text: "Dữ liệu đầu vào không hợp lệ"},
    ["5011"]: {text: "Dữ liệu đầu vào không hợp lệ"},
    ["6104"]: {text: "Tài khoản chưa được xác thực"},
    ["6110"]: {text: "Tài khoản chưa được định danh"},
    ["6111"]: {text: "Tài khoản Facepay chưa liên kết thẻ"},
    ["6118"]: {text: "Giao dịch không thành công do lỗi hệ thống"},
    ["6116"]: {text: "Số tiền giao dịch chưa đạt mức tối thiểu 10,000 đồng"},
    ["315001"]: {text: "Mã giao dịch bị trùng"},
    ["315002"]: {text: "Tài khoản Facepay chưa liên kết thẻ"},
    ["315003"]: {text: "Số dư ví không khả dụng"},
    ["315004"]: {text: "Tài khoản đang tạm khóa"},
    ["315005"]: {text: "Giao dịch không thành công do chưa xác thực giao dịch"},
    ["315006"]: {text: "Giao dịch không thành công do chưa xác thực OTP"},
    ["315007"]: {text: "Giao dịch không thành công"},
    ["315008"]: {text: "Giao dịch không thành công do lỗi hệ thống"},
    ["default"]: {text: "Giao dịch không thành công do lỗi hệ thống"},
    ["-99"]: {text: "Không nhận được lỗi từ ngân hàng"},
    ["-100"]: {text: "Giao dịch chưa hoàn tất"},

}